import { h2, paragraph, paragraphCss } from "@/styles/typography";
import { Link } from "gatsby";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  margin-bottom: 64px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(200px, 100%), 1fr));
  row-gap: 20px;
  column-gap: 34px;
  width: 100%;
  justify-items: center;

  @media screen and (max-width: 992px) {
    row-gap: 16px;
    column-gap: 16px;
  }
`;

const CardLink = styled(Link)`
  display: flex;
  flex-direction: column;
  font-weight: 700 !important;
  width: 100%;
  text-decoration: none;
  ${paragraphCss};
  color: ${({ theme }) => theme.colors.softBlack};
`;

const RelatedCasesTitle = styled(h2)`
  margin-top: 30px;
  margin-bottom: 43px;

  @media screen and (max-width: 992px) {
    margin-top: 8px;
    margin-bottom: 18px;
  }
`;

const TitlesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 7px;

  @media screen and (max-width: 992px) {
    flex-direction: column;
  }
`;
const FirstTitle = styled(paragraph)`
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;

  @media screen and (max-width: 992px) {
    font-size: 16px;
    line-height: 20px;
  }
`;

const SecondTitle = styled(FirstTitle)`
  font-weight: 400;
`;

const Margin = styled.div<{ missingHero: boolean }>`
  ${({ missingHero }) =>
    missingHero &&
    `
  margin-top: 210px;
`}

  @media screen and (max-width: 820px) {
    ${({ missingHero }) =>
      missingHero &&
      `
  margin-top: 210px;
`}
  }
`;

const S = {
  Container,
  Grid,
  CardLink,
  TitlesWrapper,
  FirstTitle,
  SecondTitle,
  RelatedCasesTitle,
  Margin,
};

export default S;
